import translate, { TranslationKey } from "../functions/translate";
import { ReactComponent as Success } from "../images/success.svg";

interface GuidelineProps {
    text: TranslationKey
    isValid: boolean
}

export const Guideline = (props: GuidelineProps) => {

    const text = translate(props.text);
    const svgSize = '30px';
    return props.isValid ?
        <li className="ds-u-display--flex ds-u-align-items--top" style={{
            marginLeft: '-22px',
            lineHeight: svgSize
        }}>
            <Success
                role="img"
                title={translate('criteria_met')}
                style={{
                    fill: '#12890E',
                    height: svgSize,
                    minWidth: svgSize
                }}
            />
            {text}
        </li> :
        <li className="ds-u-padding-left--1 ds-u-color--base" style={{
            lineHeight: svgSize
        }}>
            {text}
        </li>;
}
